import * as React from 'react'

function EmptyStraitsX(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 130 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          opacity="0.8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.0034 15.2281C28.3294 11.0361 29.5634 8.42605 30.7034 7.39705C33.8604 4.54905 38.2254 6.09905 39.1534 6.32105C42.4134 7.10305 41.3534 1.95705 44.1504 0.911054C46.0144 0.214054 47.5474 1.06605 48.7504 3.46705C49.8154 1.22705 51.4384 0.201054 53.6194 0.384054C56.8914 0.661054 58.0364 11.7121 62.5324 9.29305C67.0294 6.87305 72.5424 6.32005 74.8974 9.91605C75.4064 10.6941 75.6014 9.48705 79.0634 5.36605C82.5254 1.24405 85.9774 -0.571946 93.0594 1.82805C96.2794 2.91805 98.9274 5.87305 101.006 10.6921C101.006 17.5701 106.066 21.6421 116.184 22.9051C131.363 24.8001 119.581 41.1191 101.006 45.8981C82.4304 50.6781 39.6634 53.2581 16.4554 41.1821C0.98336 33.1331 4.49936 24.4811 27.0024 15.2281H27.0034Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M64.987 76.008C80.4438 76.008 92.974 73.1077 92.974 69.53C92.974 65.9523 80.4438 63.052 64.987 63.052C49.5302 63.052 37 65.9523 37 69.53C37 73.1077 49.5302 76.008 64.987 76.008Z"
          fill="url(#paint1_linear)"
        />
        <path
          opacity="0.675"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M111.201 77.613C90.1579 82.891 18.3309 76.854 10.6859 74.097C6.9649 72.754 3.6109 70.229 0.624903 66.521C0.290703 66.1064 0.0806373 65.6057 0.0189802 65.0767C-0.0426768 64.5478 0.0465916 64.0122 0.27647 63.5318C0.506348 63.0514 0.867453 62.6459 1.31806 62.3621C1.76866 62.0783 2.29037 61.9278 2.8229 61.928H128.337C130.942 68.866 125.23 74.094 111.201 77.613Z"
          fill="url(#paint2_linear)"
        />
        <path
          d="M86.396 57.052L76.825 45.86C76.5987 45.593 76.3174 45.3779 76.0004 45.2295C75.6833 45.0811 75.338 45.0028 74.988 45H54.408C53.702 45 53.031 45.324 52.571 45.86L43 57.052V63.196H86.396V57.052Z"
          fill="#00D37E"
        />
        <path
          d="M83.6829 63.4223L75.3059 53.6743C75.1034 53.4441 74.8538 53.2603 74.5739 53.1352C74.294 53.0101 73.9905 52.9467 73.6839 52.9493H55.7099C55.0929 52.9493 54.4899 53.2053 54.0879 53.6743L45.7109 63.4223V64.7763H83.6829V63.4223Z"
          fill="url(#paint3_linear)"
        />
        <path
          d="M86.396 70.237C86.396 71.09 86.012 71.857 85.406 72.371L85.283 72.471C84.8025 72.8352 84.2159 73.0319 83.613 73.031H45.784C45.442 73.031 45.115 72.969 44.813 72.855L44.663 72.795C44.1681 72.5748 43.7477 72.216 43.4525 71.7618C43.1574 71.3076 43.0002 70.7777 43 70.236V57.119H53.529C54.692 57.119 55.629 58.076 55.629 59.237V59.252C55.629 60.414 56.577 61.351 57.74 61.351H71.656C72.215 61.3505 72.751 61.1285 73.1467 60.7336C73.5424 60.3386 73.7654 59.803 73.767 59.244C73.767 58.078 74.705 57.119 75.867 57.119H86.397L86.396 70.237Z"
          fill="url(#paint4_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="67.7942"
          y1="37.3133"
          x2="67.7942"
          y2="-8.3702"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DEDEDE" stopOpacity="0" />
          <stop offset="1" stopColor="#A9A9A9" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="62.0708"
          y1="76.008"
          x2="62.0708"
          y2="63.052"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#96A1C5" stopOpacity="0.373" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="64.4744"
          y1="79.7064"
          x2="64.4744"
          y2="58.4301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="1" stopColor="#919191" stopOpacity="0.15" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="64.9586"
          y1="52.9492"
          x2="64.9586"
          y2="68.7763"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D7E9F9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="70.4898"
          y1="73.031"
          x2="70.4898"
          y2="56.2731"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ECFDEF" />
          <stop offset="1" stopColor="#4EC677" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="130" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default EmptyStraitsX
